import React, {useContext, useEffect} from "react"
import DepartOverallStatus from "./DepartOverallStatus";
import DepartTable from "./DepartTable";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/Constants";
import {getDocumentURL, getNodeCapability} from "../handler/ParentDataHandler";
import {getBaseUrl, parseCapabilitiesResponse} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";
import DepartFilterWrapper from "./DepartFilterWrapper";
import {MobileDisplay} from "../common/MobileDisplay";
import DepartAlertView from "../alert/DepartAlertView";

const DepartView = () => {
    const {configViewModel, configDispatch} = useContext(CapabilityContext)

    useEffect(() => {
        Promise.all([getDocumentURL(), getNodeCapability()]).then(result => {
            //const result = ["https://logistics.amazon.co.uk",{capability: "\""+CORE_AMZL+"\""}];
            const model = {
                capability: parseCapabilitiesResponse(result[1]),
                baseUrl: getBaseUrl(result[0])
            }
            configDispatch({type: 'GET_CAPABILITIES', data: model});
            configDispatch({
                type: 'GET_STATION_CONFIG',
                data: {
                    dispatcher: configDispatch,
                    baseUrl: model.baseUrl
                }
            });
        })
    }, []);

    return (
        <div>
            {configViewModel.capability && configViewModel.stationConfig.initialised ?
                <div>
                    <MobileDisplay visibility={false}>
                        <DepartAlertView />
                    </MobileDisplay>
                    <PageHeader {...PAGE_HEADERS.DEPART} />
                    <DepartFilterWrapper />
                    <DepartOverallStatus />
                    <DepartTable />
                </div> : null}
        </div>
    )
}

export default DepartView


// WEBPACK FOOTER //
// ./src/components/depart/DepartView.js